<template>
  <div>
    <h4 class="custom-padding-right pb-3">{{ $t('message.insurance.rates.title') }}</h4>
    <div class="row mx-n2">
      <div class="col mb-3 px-2" v-for="(quote, index) in insuranceQuotes" :key="index">
        <mobialisCard>
          <div class="logo">
            <template v-if="getThisIsAmerica">
              <img :src="quote.InsuranceCompanyImageUrl" :alt="quote.InsuranceCompany" />
            </template>
            <template v-else>
              <img :src="imageSrc[quote.InsuranceCompany]" :alt="quote.InsuranceCompany" />
            </template>
          </div>
          <div class="d-block">
            <h3 data-cy="quote" class="year text-center font-weight-bold pt-3">
              {{ $n(quote.Annual, 'currencyDollars', getLanguageCodeForNumericalInternationalization) }}/{{
                $t('message.common.year')
              }}
            </h3>
            <h6 v-if="showMonthlyRate(quote)" class="month text-center">
              {{ $t('message.common.or') }}
              {{ $n(quote.MonthlyPayment, 'currencyDollars', getLanguageCodeForNumericalInternationalization) }}/{{
                $t('message.common.month')
              }}
            </h6>
            <!-- Even if there is no monthly rate, still using <h6> with $nbsp; as value to keep the height of the cards consistent with each other with minimal tweaking -->
            <h6 v-else class="month text-center">&nbsp;</h6>
          </div>
          <div>
            <p class="text-center pt-3 pb-2 p-small">
              <template v-if="getThisIsAmerica">
                {{ quote.InsuranceCompany }} {{ $t('message.insurance.insuranceWrapperHeader') }}
              </template>
              <template v-else>
                {{ $t(`message.insurance.rates.${quote.InsuranceCompany.toLowerCase()}`) }}
              </template>
            </p>
          </div>
        </mobialisCard>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

const INTACT = require('@/assets/intact.svg');
const AVIVA = require('@/assets/aviva.svg');
const ECONOMICAL = require('@/assets/economical.svg');
const STATEFARM = require('@/assets/statefarm.svg');
const GEICO = require('@/assets/geico.svg');
const ALLSTATE = require('@/assets/allstate.svg');

export default {
  name: 'HorizontalRates',
  data() {
    return {
      imageSrc: {
        HAL: INTACT,
        GA: AVIVA,
        ECON: ECONOMICAL,
        SF: STATEFARM,
        GE: GEICO,
        AS: ALLSTATE,
        WU: INTACT,
      },
    };
  },
  props: {
    insuranceQuotes: {
      type: Array,
      required: true,
    },
  },
  computed: {
    ...mapGetters('business', ['getThisIsAmerica']),
    ...mapGetters('user', ['getLanguageCodeForNumericalInternationalization']),
  },
  methods: {
    // Do not want to show monthly rate if it is 0 || 0.0
    showMonthlyRate(quote) {
      return quote.MonthlyPayment;
    },
  },
};
</script>
<style lang="scss" scoped>
p {
  margin-bottom: 0;
  color: rgb(25, 34, 43);
}
img {
  max-height: 100%;
  max-width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
}
.card-body {
  padding-left: 1rem;
  padding-right: 1rem;
}
.logo {
  width: 134px;
  height: 55px;
  position: relative;
  margin: 10px auto;
}
.quote {
  height: 48px;
  width: 290px;
}
.year {
  font-size: 24px;
}
.month {
  font-size: 14px;
}
</style>
